function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0004,
  cy: 16.2856,
  r: 0.714286,
  fill: "#EE2D24"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7147 9.5C12.7147 13.5476 12.0004 14.1429 12.0004 14.1429C12.0004 14.1429 11.2861 13.5476 11.2861 9.5C11.2861 7 11.6059 7 12.0004 7C12.3949 7 12.7147 7 12.7147 9.5Z",
  fill: "#EE2D24"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 8.5,
  stroke: "#EE2D24"
});
const SvgWarningRoundIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningRoundIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning-round-icon.8cfc44b9.svg";
export { ForwardRef as ReactComponent };